export default __webpack_public_path__ + "images/bw-8a35721e3f5ff275ace83b5654e857a7.svg";